import { api } from "../api";

/**
 * workScheduleFindAllExportResponse - Function that finds on database all work schedules by status and export in a PDF/XSLX file
 * /work-schedules/{customerId}/{status}/{exportType}/export
 * method GET
 * @async-function
 */
const workScheduleFindAllExportResponse = async (token: string, customerId: number, status: string, exportType: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/work-schedules/${customerId}/${status}/${exportType}/export?simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default workScheduleFindAllExportResponse;
